import script from "./LeaveReviewForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeaveReviewForm.vue?vue&type=script&setup=true&lang=ts"

import "./LeaveReviewForm.vue?vue&type=style&index=0&id=4ce0418c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce0418c"]])

export default __exports__